module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_White_Black.ff2b9e88.png";